/**
 * Simple private util to get the DOM "instance" from either a ref object or an
 * HTMLElement.
 *
 * @param refOrInstance - The ref or instance to get an HTMLElement from
 * @returns The HTMLElement or null.
 * @internal
 */
export function getInstance(refOrInstance) {
  var instance = null;
  if (refOrInstance) {
    if (refOrInstance instanceof HTMLElement) {
      instance = refOrInstance;
    } else {
      instance = refOrInstance.current;
    }
  }
  return instance;
}